import styled from 'styled-components';
import { Box } from 'reflexbox';

export const Relative = styled(Box)`
  position: relative;
`;
